import useCheckRole from "../hooks/useCheckRole";
const AuthRouteManager = (allowedFor, router, ...routes) => {
  const checkRole = useCheckRole();
  let allowed = false;
  switch (allowedFor) {
    case 'user':
      allowed = checkRole.isUser();
      break;
    case 'physician':
      allowed = checkRole.isPhysician();
      break;
    case 'loggedOutUser':
      allowed = checkRole.isLoggedOutUser();
      break;
    default:
      break;
  }
  return allowed && routes;
};
export default AuthRouteManager;